import React from 'react';
import Agreements from './agreements/agreements';
import Onskeliste from './Onskeliste.uha';
import translation from './agreements/agreements.i18n';
import { EmptyState } from '../components/emptyState/emptyState';
import Button from '../components/button';
import * as css from './steder.uha.module.scss';
import { useActivityContextUHA } from './activitycontexts';
import AgreementsErrors from './agreements/agreementErrors';
import { listIsDefinedAndHasElements } from '../util/listutils';
import { useNavigate } from 'react-router-dom';
import { useFormatMessageFor } from '../i18n/translation';

const Steder = () => {
  const { praksisaktivitet } = useActivityContextUHA();
  const { avtaler, kapasitet } = praksisaktivitet;
  const navigate = useNavigate();

  const labels = useFormatMessageFor(translation);

  return (
    <>
      {listIsDefinedAndHasElements(avtaler) ? (
        <>
          <Agreements />
          <AgreementsErrors />
        </>
      ) : (
        <>
          <EmptyState
            title={labels.emptyStateTitle}
            text={labels.emptyStateText}
          />
          <div className={css.practiceplaceButton}>
            <Button.Secondary
              title={labels.emptyStateLink}
              onClick={() => navigate('/practiceplaces')}
            >
              {labels.emptyStateLink}
            </Button.Secondary>
          </div>
        </>
      )}
      {kapasitet > 0 && <Onskeliste />}
    </>
  );
};

export default Steder;
